import template from './errorReport.html';
import controller from './errorReport.controller';

let errorReportComponent = {
  restrict: 'E',
  bindings: {
    type: '@',
    batchId: '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default errorReportComponent;



// WEBPACK FOOTER //
// ./app/components/errorReport/errorReport.component.js